module.exports = __webpack_public_path__ + "img/w3_reload_dark.80730622.80730622.png";